import {Box} from '@mui/material';
import {colors} from '@ark/react';
import './styles.css';

export const CortileLoader = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Box width="15vh" height="15vh">
        <svg
          className="cortile-loader"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
        >
          <path
            d="M49.49 13.67 C49.81 13.87 50.2 13.87 50.52 13.67 C60.76 7.29 74.08 8.79 82.65 17.35 C91.22 25.92 92.71 39.24 86.33 49.48 C86.13 49.8 86.13 50.19 86.33 50.51 C92.71 60.75 91.21 74.07 82.65 82.64 C74.08 91.21 60.76 92.7 50.52 86.32 C50.2 86.12 49.81 86.12 49.49 86.32 C39.25 92.7 25.93 91.2 17.36 82.64 C8.79 74.07 7.3 60.75 13.68 50.51 C13.88 50.19 13.88 49.8 13.68 49.48 C7.3 39.24 8.8 25.92 17.36 17.35 C25.93 8.78 39.25 7.29 49.49 13.67 Z"
            pathLength={1}
            fill="none"
            stroke={colors.terracotta}
            strokeWidth={10}
          />
        </svg>
      </Box>
    </Box>
  );
};
